export default "__VITE_ASSET__22hf04xJ__"